export const PUBLIC_PRODUCT_FACTS = {
  calculatorCount: 136,
  regulatorySources: {
    order168n:
      'https://publication.pravo.gov.ru/Document/View/0001202204210027',
    order404n:
      'https://publication.pravo.gov.ru/Document/View/0001202106300043',
  },
} as const

export const PUBLIC_CALCULATOR_COUNT = PUBLIC_PRODUCT_FACTS.calculatorCount
export const PUBLIC_REGULATORY_SOURCE_URLS =
  PUBLIC_PRODUCT_FACTS.regulatorySources
